import { InboundETransferList } from 'vopay';
import { useEffect, FC, useState } from 'react';
import InboundETransferInfo from './InboundETransferInfo';
import useFetchInboundETransferTransaction from '@/hooks/useApi/useFetchInboundETransferTransaction';

type InboundETransferTransactionContainerProps = {
  TransactionID: string;
  isParent?: boolean;
  jwt: string;
};

const InboundETransferTransactionContainer: FC<InboundETransferTransactionContainerProps> = ({
  TransactionID,
  isParent,
  jwt,
}) => {
  const [inboundETransferTransaction, getFetchInboundETransferTransaction] = useFetchInboundETransferTransaction({
    bearer: jwt,
  });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<InboundETransferList>();

  useEffect(() => {
    getFetchInboundETransferTransaction({
      TransactionID,
    });
  }, [TransactionID]);

  useEffect(() => {
    if (inboundETransferTransaction) {
      setTransaction(inboundETransferTransaction.Transactions);
    }
  }, [inboundETransferTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <InboundETransferInfo transaction={transaction} isParent={isParent} jwt={jwt} />}</div>;
};

export default InboundETransferTransactionContainer;
